import { Entity, Field } from "typegraph";

import { IAbstractEntity } from "../fields/entitySelect/IEntitySelect";

@Entity({one: "tagSet", many: "tagSets"})
export class TagSet implements IAbstractEntity {

	@Field()
	public id: string | number;

	@Field()
	public name: string;

}

export interface ITagSetParams {
	ids?: string;
}



// WEBPACK FOOTER //
// ./src/common/form/entities/TagSet.ts